/**
 * @file
 * CTA Button component behaviors.
 */

(function (Drupal) {
  'use strict';

  /**
   * Behavior for CTA Button component.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.ctaButton = {
    attach: function (context, settings) {
      // Add any JavaScript functionality for the CTA button here if needed
      // For example, tracking clicks, handling custom interactions, etc.
    }
  };

})(Drupal);
